import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-navy border-t border-ivory/10 py-16 md:py-20" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-6">
          <div className="font-mono-ui text-xs tracking-[0.35em] text-gold uppercase">Est. London, UK</div>
          <div className="font-display text-5xl md:text-7xl text-ivory mt-4 leading-none">
            The Visa <span className="italic text-gold">Atelier</span>
          </div>
        </div>
        <div className="col-span-6 md:col-span-3">
          <div className="font-mono-ui text-xs tracking-[0.3em] uppercase text-ivory/60 mb-4">Contact</div>
          <ul className="space-y-3 text-ivory/90 text-base md:text-lg">
            <li>info@thevisaatelier.com</li>
            <li>+44 7756 766759</li>
            <li>London, UK</li>
          </ul>
        </div>
        <div className="col-span-6 md:col-span-3">
          <div className="font-mono-ui text-xs tracking-[0.3em] uppercase text-ivory/60 mb-4">Quick Links</div>
          <ul className="space-y-3 text-ivory/90 text-base md:text-lg">
            <li><a href="/#services" className="hover:text-gold">Services</a></li>
            <li><a href="/#global" className="hover:text-gold">Global</a></li>
            <li><a href="/#reviews" className="hover:text-gold">Reviews</a></li>
            <li><a href="/#book" className="hover:text-gold">Enquire</a></li>
            <li><a href="/#consultation" className="hover:text-gold">Consultation</a></li>
            <li><Link to="/about" className="hover:text-gold" data-testid="footer-about-link">About Us</Link></li>
            <li>
              <Link to="/admin/login" className="hover:text-gold" data-testid="footer-admin-link">Admin</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 mt-16 pt-8 border-t border-ivory/10">
        <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm md:text-base text-ivory/85" data-testid="footer-links-bar">
          {[
            { label: "FAQs", href: "/faqs" },
            { label: "Privacy Policy", href: "/privacy" },
            { label: "Terms & Conditions", href: "/terms" },
            { label: "Services", href: "/#services" },
            { label: `Copyright ${new Date().getFullYear()}`, href: null },
          ].map((item, idx, arr) => (
            <li key={item.label} className="flex items-center gap-x-6">
              {item.href ? (
                <Link to={item.href} className="hover:text-gold transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className="text-ivory/70">{item.label}</span>
              )}
              {idx < arr.length - 1 && (
                <span className="text-gold/50 select-none" aria-hidden>|</span>
              )}
            </li>
          ))}
        </ul>
        <div className="mt-6 pt-6 border-t border-ivory/10 flex flex-col md:flex-row justify-between gap-4 text-xs font-mono-ui uppercase tracking-[0.28em] text-ivory/60">
          <div>© {new Date().getFullYear()} The Visa Atelier</div>
          <div>Crafted with discretion</div>
        </div>
      </div>
    </footer>
  );
}
